import { render } from "./info.vue?vue&type=template&id=d2b905f0&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"

import "./info.vue?vue&type=style&index=0&id=d2b905f0&scoped=true&lang=css"
import "@/styles/common.css?vue&type=style&index=1&id=d2b905f0&scoped=true&lang=css"
import "@/styles/subcommon.css?vue&type=style&index=2&id=d2b905f0&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2b905f0"]])

export default __exports__